/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MarkAsNoShow/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function MarkAsNoShow({
  children,
  viewPath = "/DesignSystem/AppointmentActions/MarkAsNoShow"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appointmentActionsAppointmentBookingValueData = fromData.useDataFormat({ viewPath,
context: 'appointment_actions',
path: 'appointment_booking',
format: fromHelpers.shouldShow,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(appointmentActionsAppointmentBookingValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}